import * as Yup from "yup";

import {
  Button,
  Divider,
  Flex,
  Grid,
  GridItem,
  Heading,
  ListItem,
  Select,
  UnorderedList,
} from "@chakra-ui/react";
import { FormHandles, SubmitHandler } from "@unform/core";
import ReCAPTCHA, { ReCAPTCHAProps } from "react-google-recaptcha";
import React, { useRef, useState } from "react";

import { IProductItem } from "../../interfaces/Product";
import ImageInput from "./ImageInput";
import Input from "./Input";
import SelectProducts from "./selectProducts";
import Textarea from "./textarea";
import { Form as Unform } from "@unform/web";
import axios from "axios";
import styled from "styled-components";
import { useToast } from "@chakra-ui/react";

interface ErrorProps {
  [key: string]: string;
}
interface FormData {
  name: string;
  empresa: string;
  email: string;
  fotoVideo: FileList;
  notaFiscal: FileList;
}
export const Form = styled(Unform)`
  width: 100%;
`;

interface Props {
  products: IProductItem[];
}

export default function FormPF({ products }: Props) {
  const formRef = useRef<FormHandles>(null);
  const [isSubmit, setIsSubmit] = useState<boolean>(false);
  const toast = useToast();

  const recaptchaRef = React.createRef<any>();

  const handleSubmit: SubmitHandler<FormData> = async (data) => {
    // console.log(data);
    // return false;
    try {
      // Remove all previous errors
      if (formRef.current != null) {
        formRef.current.setErrors({});
      }

      const schema = Yup.object().shape({
        bairro: Yup.string().required("Campo obrigatório."),
        cep: Yup.string().required("Campo obrigatório."),
        cidade: Yup.string().required("Campo obrigatório."),
        cpf: Yup.string().required("Campo obrigatório."),
        // dataAquisicao: Yup.string().required("Campo obrigatório."),
        // dataOcorrencia: Yup.string().required("Campo obrigatório."),
        endereco: Yup.string().required("Campo obrigatório."),
        // localCompra: Yup.string().required("Campo obrigatório."),
        nome: Yup.string().required("Campo obrigatório."),
        email: Yup.string().required("Campo obrigatório."),
        telefone: Yup.string().required("Campo obrigatório."),
        uf: Yup.string().required("Campo obrigatório."),
      });
      await schema.validate(data, {
        abortEarly: false,
      });

      if (data.fotoVideo) {
        const arrayFotoVideo = Array.from(data.fotoVideo as any);

        const totalSize = arrayFotoVideo.reduce(
          (acc, file: any) => Number(acc) + Number(file.size),
          0
        );

        if (Number(totalSize) / 1024 / 1024 >= 10) {
          toast({
            title: "Tamanho máximo total excedido",
            description:
              "O limite tota de todos arquivos não pode ultrapassar 10MB",
            status: "error",
            duration: 9000,
            isClosable: true,
          });
          return;
        }
      }

      const recaptchaValue = recaptchaRef.current?.getValue();
      if (!recaptchaValue) {
        toast({
          title: "Erro",
          description: "Por favor, confirme que você não é um robô.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        return;
      }

      // Validation passed
      // SEND MAIL
      const formInfo = {
        ...data,
        motivoOcorrencia: motivoOcorrencia.join(","),
      };
      {
        let data = new FormData();
        data.append("data", JSON.stringify(formInfo));
        const arrayFotoVideo = Array.from(formInfo.fotoVideo as any);
        arrayFotoVideo.forEach((file: any) => {
          data.append("files.fotoVideo", file);
        });
        const arrayNotaFiscal = Array.from(formInfo.notaFiscal as any);
        arrayNotaFiscal.forEach((file: any) => {
          data.append("files.fotoVideo", file);
        });
        // data.append("files.notaFiscal", formInfo.notaFiscal);
        // set files.photo binary from file list

        const sending = await axios.post(
          `${
            process.env.NEXT_PUBLIC_STRAPI_API_URL || "http://localhost:1337"
          }/form/pf`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
      }
      console.log(data);
      toast({
        title: "Solicitação enviada.",
        description: "Em breve entraremos em contato.",
        status: "success",
        duration: 9000,
        isClosable: true,
      });
    } catch (err) {
      console.log(err);
      const validationErrors: ErrorProps = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          if (error.path != undefined) {
            validationErrors[error.path] = error.message;
          }
        });
        if (formRef.current != null) {
          formRef.current.setErrors(validationErrors);
        }
      }
    }
  };

  const [motivoOcorrencia, setMotivoOcorrencia] = useState<string[]>([]);

  const handleCheck = (event: any) => {
    var updatedList = [...motivoOcorrencia];
    if (event.target.checked) {
      updatedList = [...motivoOcorrencia, event.target.value];
    } else {
      updatedList.splice(motivoOcorrencia.indexOf(event.target.value), 1);
    }
    setMotivoOcorrencia(updatedList);
  };

  return (
    <Flex w="full" py="30px" flexDir="column">
      <Flex w="full">
        <Form ref={formRef} onSubmit={handleSubmit}>
          <Grid
            templateColumns={[
              "repeat(1, 1fr)",
              "repeat(1, 1fr)",
              "repeat(1, 1fr)",
              "repeat(2, 1fr)",
            ]}
            columnGap={8}
            rowGap="0"
          >
            <GridItem w="full" flexDir="column">
              <Input
                name="nome"
                label="Nome completo"
                type="text"
                placeholder="Insira seu nome completo"
              />
            </GridItem>
            <GridItem w="full" flexDir="column">
              <Input
                name="cpf"
                label="CPF"
                type="text"
                placeholder="Insira seu CPF"
              />
            </GridItem>

            <GridItem w="full" flexDir="column">
              <Input
                name="endereco"
                label="RUA E NÚMERO"
                type="text"
                placeholder="Insira sua rua e número"
              />
            </GridItem>
            <GridItem w="full" flexDir="column">
              <Input
                name="bairro"
                label="BAIRRO"
                type="text"
                placeholder="Insira seu nome do seu bairro"
              />
            </GridItem>

            <GridItem w="full" flexDir="column">
              <Input
                name="cidade"
                label="CIDADE"
                type="text"
                placeholder="Insira o nome da sua cidade"
              />
            </GridItem>
            <GridItem w="full" flexDir="column">
              <Input
                name="uf"
                label="UF"
                type="text"
                placeholder="Insira sua UF"
              />
            </GridItem>

            <GridItem w="full" flexDir="column">
              <Input
                name="cep"
                label="CEP"
                type="text"
                placeholder="Insira seu CEP"
              />
            </GridItem>
            <GridItem w="full" flexDir="column">
              <Input
                name="telefone"
                label="TELEFONE"
                type="text"
                placeholder="(XX) X XXXX XXXX"
              />
            </GridItem>
          </Grid>
          <GridItem w="full" flexDir="column" colSpan={2}>
            <Input
              name="email"
              label="E-mail"
              type="text"
              placeholder="Digite seu e-mail"
            />
          </GridItem>

          <Divider borderBottomWidth="2px" my={8} />

          <Grid
            templateColumns={[
              "repeat(1, 1fr)",
              "repeat(1, 1fr)",
              "repeat(1, 1fr)",
              "repeat(2, 1fr)",
            ]}
            columnGap={8}
            rowGap="0"
          >
            <GridItem w="full" flexDir="column">
              {products && (
                <SelectProducts
                  name="produto"
                  label="Selecione o produto"
                  products={products}
                />
              )}
            </GridItem>
            <GridItem w="full" flexDir="column">
              <Input
                name="codProduto"
                label="código do produto selecionado"
                type="text"
                placeholder="Insira o código do produto selecionado"
              />
            </GridItem>

            <GridItem w="full" flexDir="column" colSpan={2}>
              <Textarea
                name="defeito"
                label="DEFEITO/FATO"
                placeholder="Descreva o defeito/fato"
              />
            </GridItem>

            <GridItem w="full" flexDir="column">
              <ImageInput
                name="fotoVideo"
                label="FOTOS e vídeos DO DEFEITO/FATO"
                placeholder="Selecione fotos e vídeos que mostrem o defeito"
              />
            </GridItem>
            <GridItem w="full" flexDir="column">
              <ImageInput
                name="notaFiscal"
                label="NOTA FISCAL DA COMPRA"
                placeholder="Anexe a nota fiscal da compra do produto"
              />
            </GridItem>
          </Grid>

          <Divider borderBottomWidth="2px" my={8} />

          <Grid
            templateColumns={[
              "repeat(1, 1fr)",
              "repeat(1, 1fr)",
              "repeat(1, 1fr)",
              "repeat(2, 1fr)",
            ]}
            columnGap={8}
            rowGap="0"
          >
            <GridItem w="full" flexDir="column">
              <Input
                name="dataAquisicao"
                label="DATA DA AQUISIÇÃO"
                type="text"
                placeholder="Insira a data que você adquiriu o produto"
              />
            </GridItem>
            <GridItem w="full" flexDir="column">
              <Input
                name="dataOcorrencia"
                label="DATA DA OCORRÊNCIA"
                type="text"
                placeholder="Insira a data que ocorreu o defeito/fato"
              />
            </GridItem>

            <GridItem w="full" flexDir="column">
              <Input
                name="localCompra"
                label="LOCAL DA COMPRA"
                type="text"
                placeholder="Insira o local em que o produto foi comprado"
              />
            </GridItem>
            <GridItem w="full" flexDir="column">
              <Input
                name="cnpjFone"
                label="CNPJ/FONE"
                type="text"
                placeholder="XX. XXX. XXX/0001-XX    -    (XX) X XXXX XXXX"
              />
            </GridItem>
          </Grid>

          <Flex justifyContent="space-between">
            <Button
              mt={4}
              colorScheme="teal"
              isLoading={isSubmit}
              type="submit"
              bgColor="#007DC5"
              fontSize="14px"
              borderRadius="12px"
              px={14}
              _hover={{ bgColor: "#007DC5" }}
            >
              Enviar formulário
            </Button>

            <ReCAPTCHA
              sitekey="6LfAbYUeAAAAANymlm8n_qR1FqN9KFEWtG1Bd0yN"
              ref={recaptchaRef}
            />
          </Flex>
        </Form>
      </Flex>
      <Divider borderBottomWidth="2px" my={8} />
      <Flex flexDir="column">
        <Heading as="h3" fontSize="24px" mb={6}>
          Instruções
        </Heading>
        <UnorderedList>
          <ListItem>Preencher todos os campos do formulário;</ListItem>
          <ListItem>Informar o código do produto;</ListItem>
          <ListItem>
            Informar o nº de série e a data de fabricação quando se tratar de
            PURIFICADOR;
          </ListItem>
          <ListItem>Evidenciar o defeito/fato com fotos e vídeos;</ListItem>
          <ListItem>
            Após o preenchimento aguarde o retorno da fábrica. O nosso prazo de
            resposta é de aproximadamente 24 horas úteis, para ambos os
            formulários (PF e PJ).
          </ListItem>
        </UnorderedList>
      </Flex>
    </Flex>
  );
}
